import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {UtilsService} from "../../shared/utils.service";
import {GlobalConfigurationService} from "./global-configuration.service";

@Component({
    selector: 'app-global-configuration',
    templateUrl: './global-configuration.component.html',
    styleUrls: ['./global-configuration.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GlobalConfigurationComponent implements OnInit {

  inProgress: boolean = false;
  isSentryActive: boolean = false;
  quickAccessDurationHours: number = 12;
  quickAccessHourOptions: number[] = Array.from({length: 24}, (_, i) => i + 1);

  // Membership approvals rollout flag (SC-301). Decides whether joining an account that already exists
  // becomes a request somebody has to approve, or is granted immediately as it was before the feature.
  accountLinkApprovalsEnabled: boolean = false;

  constructor(
    private utils: UtilsService,
    private global: GlobalConfigurationService
  ) {}

  ngOnInit() {
    this.inProgress = true;

    Promise.all([
      this.global.getSettingValueByKey('sentry_kill_switch'),
      this.global.getSettingValueByKey('super_admin_quick_access_duration_hours'),
      this.global.getSettingValueByKey('account_link_approvals_enabled')
    ]).then(([sentryResponse, quickAccessResponse, approvalsResponse]) => {
      this.isSentryActive = sentryResponse && sentryResponse?.data?.status === 'on';
      if (quickAccessResponse && quickAccessResponse?.data?.hours) {
        this.quickAccessDurationHours = quickAccessResponse.data.hours;
      }
      // Anything that is not an explicit true reads as off, matching the API side, so a missing or
      // malformed setting leaves approvals disabled rather than silently switching them on.
      this.accountLinkApprovalsEnabled = !!(approvalsResponse && approvalsResponse?.data?.enabled);
      this.inProgress = false;
    });
  }

  /**
   * Saves the configuration setting for Sentry kill switch in the global settings.
   *
   * @return {void}
   */
  onSave() {
    if ( this.inProgress ) {
      return;
    }

    this.inProgress = true;

    const newStatus = this.isSentryActive ? 'on' : 'off';
    Promise.all([
      this.global.updateSettingValueByKey('sentry_kill_switch', { status: newStatus }),
      this.global.updateSettingValueByKey('super_admin_quick_access_duration_hours', { hours: this.quickAccessDurationHours }),
      this.global.updateSettingValueByKey('account_link_approvals_enabled', { enabled: this.accountLinkApprovalsEnabled })
    ]).then(([sentryResponse, quickAccessResponse, approvalsResponse]) => {
      if(sentryResponse && quickAccessResponse && approvalsResponse) {
        this.utils.showToast('Updated global configuration');
      }
      this.inProgress = false;
    });
  }

}
